import { useProductOverlaidList } from 'common/queries/product-module';
import { useCheckIsProductOverlay } from 'hooks';
import { useParams } from 'react-router-dom';

export const useCheckOverlaidList = () => {
  const { id } = useParams();
  const isProductOverlay = useCheckIsProductOverlay();

  const { data: productOverlaidListData } = useProductOverlaidList(
    {
      productId: Number(id),
    },
    { enabled: !isProductOverlay }
  );

  return {
    hasOverlaidList: productOverlaidListData?.gridData?.length > 0,
  };
};
